import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=e2692af8&scoped=true"
import script from "./Announce.vue?vue&type=script&lang=js"
export * from "./Announce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2692af8",
  null
  
)

export default component.exports